// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import qs from 'qs';
// import swiper from 'swiper'
Vue.use(ElementUI);
// Vue.use(swiper)

// 以上代码便完成了 Element 的引入。需要注意的是，样式文件需要单独引入。
import axios from 'axios'
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
import App from './App'
import router from './router'
Vue.config.productionTip = false
// Vue.prototype.$http = "http://115.29.185.211:8033/huban-dcfadmin/"; //测试
Vue.prototype.$http = "http://101.37.39.157:8080/huban-dcfadmin/"; //真实
// Vue.prototype.$http = "http://192.168.1.240:8080/huban-dcfadmin/"; //真实更改
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js